import { render, staticRenderFns } from "./VoteChip.vue?vue&type=template&id=18e2ddc5"
import script from "./VoteChip.vue?vue&type=script&lang=js"
export * from "./VoteChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports